import mergeOperations from "@/util/shallowMerge"
import {
  useQuery 
} from "@apollo/client"
import {
  useMemo 
} from "react"
import DEFAULT_OPERATIONS from "./weddingAccessoriesPage.gql"

export const useWeddingAccessoriesPage = (props) => {
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const {
    getWeddingAccessories 
  } = operations

  const {
    data: weddingAccessoriesData, loading 
  } = useQuery(
    getWeddingAccessories,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  )

  const items = useMemo(() => {
    if (weddingAccessoriesData) {
      const {
        getWeddingAccessories 
      } = weddingAccessoriesData

      return getWeddingAccessories.items
    }

    return []
  }, [weddingAccessoriesData])

  const seoRichSnippets = useMemo(() => {
    if (weddingAccessoriesData) {
      const {
        getWeddingAccessories 
      } = weddingAccessoriesData

      return getWeddingAccessories.seo_rich_snippets
    }

    return []
  }, [weddingAccessoriesData])

  return {
    seoRichSnippets,
    loading,
    items,
  }
}
